import React, {memo} from "react";

export const IconArrowGray = memo(({color}) => {
  return (
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0715 17.0711C20.9747 13.1678 20.9747 6.83216 17.0715 2.92893C13.1683 -0.974297 6.8326 -0.974297 2.92938 2.92893C-0.973855 6.83216 -0.973855 13.1678 2.92938 17.0711C6.8326 20.9743 13.1683 20.9743 17.0715 17.0711ZM8.58621 11.5858L5.75779 8.75736L7.172 7.34315L10.0004 10.1716L12.8289 7.34315L14.2431 8.75736L11.4146 11.5858L10.0004 13L8.58621 11.5858Z"
        fill={color || "#A9A9A9"}
      />
    </svg>
  );
});
